// src/components/Detail/DetailHeader.js

import React, { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faHeart, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { toast } from 'react-toastify';

const DetailHeader = ({ producto }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [favoritos, setFavoritos] = useLocalStorage('favoritos', []);

    const isFavorito = favoritos.includes(producto.idProducto);

    const goBack = useCallback(() => {
        location.key !== 'default' ? navigate(-1) : navigate('/');
    }, [navigate, location.key]);

    const toggleFavorite = useCallback(() => {
        const newFavoritos = isFavorito
            ? favoritos.filter(id => id !== producto.idProducto)
            : [...favoritos, producto.idProducto];
        setFavoritos(newFavoritos);
        toast.info(isFavorito ? 'Eliminado de favoritos' : 'Agregado a favoritos', { autoClose: 1000 });
    }, [favoritos, isFavorito, producto.idProducto, setFavoritos]);

    const handleShare = useCallback(() => {
        if (navigator.share) {
            navigator.share({
                title: producto.titulo,
                text: '¡Mira este increíble producto!',
                url: window.location.href,
            }).catch(error => console.error('Error al compartir', error));
        } else {
            toast.info('La función de compartir no está disponible en este navegador.');
        }
    }, [producto.titulo]);

    return (
        <header className="modern-header">
           
            <button className="modern-back-btn" onClick={goBack} aria-label="Volver">
                <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <div className="modern-header-actions">
                <button onClick={toggleFavorite} className='modern-fav-btn' aria-label="Añadir a favoritos">
                    <FontAwesomeIcon icon={faHeart} style={{ color: isFavorito ? '#ff4757' : '#57606f' }}/>
                </button>
                <button className="modern-share-btn" onClick={handleShare} aria-label="Compartir">
                    <FontAwesomeIcon icon={faExternalLinkAlt} />
                </button>
            </div>
        </header>
    );
};

export default React.memo(DetailHeader);